import { useCallback, useState, useEffect } from 'react';
var BreakPoint;

(function (BreakPoint) {
  BreakPoint["xs"] = "xs";
  BreakPoint["s"] = "s";
  BreakPoint["m"] = "m";
  BreakPoint["l"] = "l";
  BreakPoint["xl"] = "xl";
})(BreakPoint || (BreakPoint = {}));

var useScreenSize = function useScreenSize() {
  var isClient = typeof window === 'object';
  var getSize = useCallback(function () {
    return {
      width: isClient ? window.innerWidth : 0,
      height: isClient ? window.innerHeight : 0,
      screen: BreakPoint.s
    };
  }, [isClient]);

  var _useState = useState(getSize),
      screenSize = _useState[0],
      setScreenSize = _useState[1];

  useEffect(function () {
    if (!isClient) {
      return;
    }

    function handleResize() {
      setScreenSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (screenSize.width < 576) {
    screenSize.screen = BreakPoint.xs;
  } else if (screenSize.width >= 576 && screenSize.width < 768) {
    screenSize.screen = BreakPoint.s;
  } else if (screenSize.width >= 768 && screenSize.width < 992) {
    screenSize.screen = BreakPoint.m;
  } else if (screenSize.width >= 992 && screenSize.width < 1200) {
    screenSize.screen = BreakPoint.l;
  } else {
    screenSize.screen = BreakPoint.xl;
  }

  return screenSize;
};

export default useScreenSize;
export { BreakPoint };